export default "__VITE_ASSET__eba5ac9a__"